import { render } from "./ZoomOut.vue?vue&type=template&id=23405173"
import script from "./ZoomOut.vue?vue&type=script&lang=js"
export * from "./ZoomOut.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__